{
  "dailyChecklist": {
    "title": "Misiones diarias",
    "subtitle": "Comunidad Circle",
    "bonusTitle": "Trifecta diaria",
    "bonusDescription": "Completa las 3 para un bonus extra",
    "tasks": {
      "post": {
        "title": "Crear una publicación",
        "description": "Publica un post en la comunidad"
      },
      "comment": {
        "title": "Hacer un comentario",
        "description": "Comenta en un post de la comunidad"
      },
      "like": {
        "title": "Dar me gusta a un post",
        "description": "Da me gusta a un post o comentario en la comunidad"
      }
    }
  },
  "toasts": {
    "xpEarned": "¡+{{xp}} XP conseguidos!",
    "xpEarnedDescription": "¡Sigue así para subir de nivel!",
    "streakMilestone_one": "🔥 ¡{{count}} día consecutivo!",
    "streakMilestone_zero": "🔥 ¡{{count}} días consecutivos!",
    "streakMilestone_other": "🔥 ¡{{count}} días consecutivos!",
    "streakMilestoneDescription": "¡Tu dedicación es inspiradora!",
    "streakUpdated": "¡Racha actualizada!",
    "consecutiveDays_one": "{{count}} día consecutivo",
    "consecutiveDays_zero": "{{count}} días consecutivos",
    "consecutiveDays_other": "{{count}} días consecutivos"
  }
}
